export default function AboutPage() {
  return (
    <div className="prose w-full max-w-4xl py-10">
      <h1>About Keypath Labs</h1>
      <p>
        Keypath Labs builds Quizzler, a lightweight practice space for students, engineers, and developers who want to
        sharpen their circuits and networking fundamentals without friction. No accounts are required—open the site and
        start working through problems right away.
      </p>

      <h2>What we care about</h2>
      <ul>
        <li>Clear, focused questions that feel like the real exam room.</li>
        <li>Fast load times and a distraction-free interface.</li>
        <li>Practical explanations that reinforce the underlying concepts.</li>
      </ul>

      <h2>How we keep the lights on</h2>
      <p>
        You may see Google Ads placements. They help us keep Quizzler free to use while we continue to add more practice
        sets and visualizations.
      </p>

      <h2>Reach us</h2>
      <p>
        Questions, ideas, or issues? Email <a href="mailto:support@keypathlabs.com">support@keypathlabs.com</a>.
      </p>
    </div>
  );
}
